interface Props {
  icon: React.ElementType | string;
  title: string;
  subtitle?: string;
  badge?: string;
  badgeVariant?: 'gold' | 'violet' | 'premium';
  right?: React.ReactNode;
}

export function ToolHeader({ icon: Icon, title, subtitle, badge, badgeVariant = 'gold', right }: Props) {
  const badgeStyle: React.CSSProperties = {
    display: 'inline-block',
    padding: '0.15rem 0.6rem',
    borderRadius: '999px',
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    marginLeft: '0.5rem',
    verticalAlign: 'middle',
    ...(badgeVariant === 'violet'
      ? { background: 'rgba(123,91,194,0.18)', color: 'var(--violet-300)', border: '1px solid rgba(123,91,194,0.35)' }
      : badgeVariant === 'premium'
      ? { background: 'rgba(31,78,95,0.15)', color: 'var(--petrol)', border: '1px solid var(--border-gold)' }
      : { background: 'rgba(31,78,95,0.12)', color: 'var(--petrol)', border: '1px solid rgba(31,78,95,0.25)' }),
  };

  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '1.5rem', gap: '1rem' }}>
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.875rem' }}>
        <div style={{
          width: '42px', height: '42px', flexShrink: 0,
          borderRadius: 'var(--radius-md)',
          background: 'rgba(31,78,95,0.08)',
          border: '1px solid var(--border-gold)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: 'var(--petrol)',
          marginTop: '2px',
        }}>
          {typeof Icon === 'string'
            ? <span style={{ fontSize: '1.25rem', lineHeight: 1 }}>{Icon}</span>
            : <Icon size={20} aria-hidden />
          }
        </div>

        <div>
          <h1
            className="font-display"
            style={{ fontSize: 'clamp(1.25rem,3.5vw,1.625rem)', color: 'var(--text-primary)', margin: 0, lineHeight: 1.25 }}
          >
            {title}
            {badge && <span style={badgeStyle}>{badge}</span>}
          </h1>
          {subtitle && (
            <p style={{ color: 'var(--text-secondary)', fontSize: 'var(--text-label)', margin: '0.3rem 0 0', lineHeight: 1.5 }}>
              {subtitle}
            </p>
          )}
        </div>
      </div>

      {right && <div style={{ flexShrink: 0 }}>{right}</div>}
    </div>
  );
}
